import React from "react";

import LearnerClassroomTabbedLayout from "../../layout/LearnerClassroomTabbedLayout";
import LearnerClassroomV2Layout from "../../layout/LearnerClassroomV2Layout";
import {
  LearnerClassroomProvider,
  useLearnerClassroomContext,
} from "../../providers/LearnerClassroomProvider";

/** Picks V2 (no-tab) or V1 (tabbed) layout based on context. */
const LearnerClassroomLayoutSwitch = () => {
  const { syllabus, section } = useLearnerClassroomContext();
  const isSelfPaced = section?.is_self_paced === true;
  const isV2Layout = syllabus?.layoutVersion === 2;

  if (isV2Layout && isSelfPaced) {
    return <LearnerClassroomV2Layout />;
  }

  return <LearnerClassroomTabbedLayout />;
};

interface LearnerClassroomProps {
  sectionUid: string;
}

const LearnerClassroom = ({ sectionUid }: LearnerClassroomProps) => {
  return (
    <LearnerClassroomProvider sectionUid={sectionUid}>
      <LearnerClassroomLayoutSwitch />
    </LearnerClassroomProvider>
  );
};

export default React.memo(LearnerClassroom);
